import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import useStyles from './match-play-scores.styles'

const MatchPlayScores = (props) => {
  const {
    score,
    country,
    thru,
    isLeader,
    justify,
  } = props
  const styles = useStyles()

  const defineScoreToDisplay = (countryScore, countryThru, countryIsLeader) => {
    if (countryScore === 'c') return { scoreNumber: 'C', scoreSymbols: 'Conceded' }
    if (countryScore === 'w') return { scoreNumber: 'W', scoreSymbols: 'Winner' }
    if (countryScore === 'T') return { scoreNumber: '', scoreSymbols: 'Tied' }
    if (!countryScore || !countryIsLeader) return { scoreNumber: '', scoreSymbols: '' }
    return countryThru === 'F'
      ? {
        scoreNumber: countryScore.substring(0, 1),
        scoreSymbols: countryScore.substring(1, 5).replace(/ /g, ''),
      }
      : {
        scoreNumber: countryScore.substring(0, 1),
        scoreSymbols: 'up',
      }
  }

  const defineClassName = (countryScore, countryName) => {
    if (countryScore === 'T' || countryScore === 'c') return 'neutral'
    if (countryScore === 'w') return 'winner'
    if (countryName === 'usa') return 'usa'
    return 'intl'
  }

  const defineAddClassName = (countryScore) => {
    if (countryScore === 'c' || countryScore === 'w') return 'conceded'
    return ''
  }

  const { scoreNumber, scoreSymbols } = defineScoreToDisplay(score, thru, isLeader)

  const className = defineClassName(score, country)
  const additionalClassName = defineAddClassName(score)

  return (
    <Box
      justifyContent={justify}
      className={`${styles.scoresWrapper} ${className}`}
    >
      <Typography variant="h2">{scoreNumber}</Typography>
      <Typography className={additionalClassName} variant="h4">{scoreSymbols}</Typography>
    </Box>
  )
}

MatchPlayScores.propTypes = {
  score: PropTypes.string,
  country: PropTypes.string,
  thru: PropTypes.string,
  isLeader: PropTypes.bool,
  justify: PropTypes.string,
}

export default MatchPlayScores
